// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__322xk","footer":"ChangeClinic_footer__1YMCF"};